const translations = {
    reticle: 'Reticle',
    touch: 'Touch'
};

export default translations;
